import { helpers }  from '../helpers.js';

var tabs = {

	selectors: {
        element: '[data-tabs]',
        trigger: '[data-tabs-target]',
        target:  '[data-tabs-id]'
    },

    options: {
        fixedHeight: false,
    },

    states: {
        current: null,
        init: null
    },

    init: function(){
        var self = this;
        self.scroll = new SmoothScroll( '[data-smooth-scroll]', {
            offset: 78,
        } );

        $( self.selectors.element ).each( function() {
            var $element = $( this ),
            id          = $element.attr( 'data-tabs' ),
            mobile      = $element.attr( 'data-tabs-mobile' ),
            $wrapper    = $element.find( '[data-tabs-wrapper="' + id + '"]' ),
            $navigation = $element.find( '[data-tabs-nav="' + id + '"]' ),
            $targets    = $wrapper.children( self.selectors.target ),
            $triggers   = $navigation.add( $targets ).children( self.selectors.trigger );

            self.states.current = $targets.filter( '.active' ).attr( 'data-tabs-id' );
            self.states.init = self.states.current;

            if ( $( '[data-tabs-modal="' + self.states.current + '"]' ).length > 0 ) {
                $( '[data-tabs-modal="' + self.states.current + '"]' ).trigger( 'open' );
            }

            $triggers.on( 'click', function(e) {
                e.preventDefault();

                var $tabItem = $( this ),
                tabID = $tabItem.attr( 'data-tabs-target' ),
                tabLink = $tabItem.attr( 'data-tabs-link' ),
                $target = $targets.filter( '[data-tabs-id="' + tabID + '"]' ),
                $modal = $( '[data-tabs-modal="' + tabID + '"]' );

                if ( mobile === 'select' && $( window ).width() < 992 && $navigation.hasClass( 'opened' ) === false ) {
                    $navigation.addClass( 'opened' );
                    return;
                }

                if ( $target.length > 0 ) {
                    $navigation.removeClass( 'opened' );
                    $triggers.removeClass( 'active' );
                    $targets.removeClass( 'active' );

                    $triggers.filter( '[data-tabs-target="' + tabID + '"]' ).addClass( 'active' );
                    $target.addClass( 'active' );
                    self.states.current = tabID;
                    $element.trigger( 'change' );
                }

                if ( mobile !== 'select' && $( window ).width() < 992 ) {
                    self.scroll.animateScroll( $target[0] );
                }

                if ( $modal.length > 0 ) {
                    $modal.trigger( 'open' );
                }

                history.pushState( { target: tabID }, $( document.title ), tabLink );
            } );

            $( document.body ).on( 'touchstart click', function(e) {
                if ( ! $( e.target ).closest( '[data-tabs-nav]' ).length ) {
                    $navigation.removeClass( 'opened' );
                }
            } );

            $( window ).on( 'popstate', function(e) {
                var tabID = self.states.init;

                if ( typeof e.originalEvent.state !== 'null' && e.originalEvent.state !== null ) {
                    if ( ( typeof e.originalEvent.state.target !== 'undefined' || typeof e.originalEvent.state.target !== 'null' ) ) {
                        tabID = e.originalEvent.state.target;
                    }
                }

                var $tabItem = $triggers.filter( '[data-tabs-target="' + tabID + '"]' ),
                $target = $targets.filter( '[data-tabs-id="' + tabID + '"]' );

                if ( $target.length > 0 ) {
                    $triggers.removeClass( 'active' );
                    $targets.removeClass( 'active' );

                    $tabItem.addClass( 'active' );
                    $target.addClass( 'active' );
                    self.states.current = tabID;
                    $element.trigger( 'change' );
                }

                if ( mobile !== 'select' && $( window ).width() < 992 ) {
                    self.scroll.animateScroll( $target[0] );
                }
            } );
        } );
    }

}

export { tabs };
